<template>
  <div>
    <z-title class="reset-password__title" tag="h1" size="medium">
      Altere sua senha
    </z-title>
    <form @submit.prevent="submitResetPasswordForm()">
      <z-input-field
        label="Defina sua nova senha"
        :has-error="resetPasswordForm.fields.password.hasError"
        :error-message="resetPasswordForm.fields.password.error"
      >
        <z-input
          v-model="resetPasswordForm.fields.password.value"
          :has-error="resetPasswordForm.fields.password.hasError"
          placeholder="Informe sua senha"
          type="password"
          alt="Confirme sua nova senha"
          autocomplete="off"
        />
      </z-input-field>

      <z-input-field
        label="Senha"
        :has-error="resetPasswordForm.fields.passwordConfirmation.hasError"
        :error-message="resetPasswordForm.fields.passwordConfirmation.error"
      >
        <z-input
          v-model="resetPasswordForm.fields.passwordConfirmation.value"
          :has-error="resetPasswordForm.fields.passwordConfirmation.hasError"
          placeholder="Confirme sua nova senha"
          type="password"
          alt="Confirme sua nova senha"
          autocomplete="off"
        />
      </z-input-field>

      <z-button
        :is-loading="submittingResetPasswordForm"
        variant="primary"
        size="medium"
        behavior="block"
        type="submit"
        alt="Alterar senha"
      >
        Alterar senha
      </z-button>
    </form>
  </div>
</template>

<script>
import { FormGroup } from 'utils/form';
import CurrentStudentService from 'services/CurrentStudentService';

export default {
  props: {
    resetPasswordToken: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      submittingResetPasswordForm: false,
      resetPasswordForm: new FormGroup({
        password: { required: true, minLength: 6 },
        passwordConfirmation: { required: true, minLength: 6, matchPassword: 'password' },
        resetPasswordToken: { },
      }),
    };
  },
  beforeMount() {
    this.resetPasswordForm.addValues({ resetPasswordToken: this.resetPasswordToken });
  },
  methods: {
    submitResetPasswordForm() {
      if (this.resetPasswordForm.validateForm()) {
        this.submittingResetPasswordForm = true;

        CurrentStudentService.resetPassword(this.resetPasswordForm.getRawValue())
          .then(() => {
            this.$toast.show('success', 'Senha alterada com sucesso', 4000);
            this.$router.replace({ name: 'login' });
          })
          .catch(() => {
            this.$toast.show('danger', 'Um erro ocorreu durante a alteração de senha, tente novamente', 4000);
          })
          .finally(() => {
            this.submittingResetPasswordForm = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.reset-password__title {
  margin-bottom: var(--space-large);
}
</style>
